var E = /* @__PURE__ */ ((e) => (e.BERRY = "berry", e.PURPLE = "purple", e.MIDNIGHT_BLUE = "midnight-blue", e.ORANGE = "orange", e.DARK_MINT = "dark-mint", e.MINT = "mint", e.WHITE = "white", e.NONE = "none", e.ACTION_BLUE = "action-blue", e.AMERIPRISE_BLUE = "ampf-blue", e.LIGHT_BLUE = "light-blue", e.DARK_GREY = "grey-dark", e.LIGHT_GREY = "grey-light", e))(E || {});
export {
  E as BrandIconColor
};
//# sourceMappingURL=BrandIconColor.type.mjs.map
